export enum UserAssignmentsRoles {
  ASSIGNER = 'roles.userAssignmentsAssigner',
}
